import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import {MatIconModule} from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { TrainingThemeSelectionListComponent } from '../../../../shared-components/selection-list/training-theme-selection-list/training-theme-selection-list.component';
import { TrainingSelectionListComponent } from "../../../../shared-components/selection-list/training-selection-list/training-selection-list.component";
//import { WorkingScheduleComponent } from "../calendar/working-schedule/working-schedule.component";

@Component({
  selector: 'app-taining-plan-details',
 imports: [MatSelectModule, MatInputModule, MatFormFieldModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule,
    MatIconModule, MatRadioModule, TrainingThemeSelectionListComponent, TrainingSelectionListComponent //WorkingScheduleComponent
     ],
  templateUrl: './taining-plan-details.component.html',
  styleUrl: './taining-plan-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TainingPlanDetailsComponent {

}
 